define('ItemAvailability.Transaction.Line.Views.Cell.Navigable.View', [
    'Transaction.Line.Views.Cell.Navigable.View',
    'underscore',
    'ItemAvailability.View'
], function ItemAvailabilityTransactionLineViewsCellNavigableView(
    TransactionLineViewsCellNavigableView,
    _,
    ItemAvailabilityView
) {
    'use strict';

    return TransactionLineViewsCellNavigableView.extend({
        childViews: _.extend(TransactionLineViewsCellNavigableView.prototype.childViews, {
            'ItemAvailability.View': function ItemAvailabilityViewFn() {
                return new ItemAvailabilityView({
                    model: this.model
                });
            }
        })
    });
});
